import { useState,useEffect } from 'react';
import GruntComponents from '../components';
import ComponentHeader from '../main/ComponentHeader';
import { Box, IconButton,Spacer , Input,InputGroup,InputLeftElement,Tooltip,SkeletonCircle, Stack,Button,
SkeletonText,useToast,DrawerContent,DrawerHeader,DrawerBody, Drawer, DrawerOverlay,DrawerCloseButton,DrawerFooter} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { MdFilterAlt,MdSaveAlt,MdCancel,MdListAlt } from 'react-icons/md';
import GruntPager from '../custom/GruntPager';
import { SpecifikacijaTable } from './SpecifikacijeTable';
import { getSpecifikacije,addSpecifikacija,delSpecifikacija,updateSpecifikacija,createMigracijaFromSpecifikacija,
  getSpecifikacijaUsnihMarkicaPdf,getOrganizatori,getVetSpecifikacijaXlsx
 } from "../../util/apiSpecifikacija"
import { SpecifikacijaItem } from './SpecifikacijaItem';
import { loggedOper as lp } from "../../util/grunt";

export default function Specifikacije({onClosePress,size='xs'}) {
  const [data,setData]=useState([])
  const [novaspecifikacija,setNovaSpecifikacija]=useState(null);
  const [dataisloading,setDataIsLoading]=useState(true);
  const [prikaz, setPrikaz] = useState({orderbycol:"datum",orderby:"desc",rowsperpage:25,currpage:1});
  const [msg,setMsg]=useState({type:"",msg:""})
  const [organizatori,setOrganizatori]=useState([]);
  const [startnewspec,setStartNewSpec]=useState(false);
  const [starteditspec,setStartEditSpec]=useState({specid:0,start:false,readonly:false});
  const [specdatacanbesaved,setSpecDataCanBeSaved]=useState(true);
  const [togglerefreshdata,setToggleRefreshData]=useState(false);
  const isReadOnly=lp.uloga==="r" || lp.uloga==="v";
  const toast=useToast();
  useEffect(() => {
    const getData=async()=>{
      let _error=false;
      try {
          const _res=await getSpecifikacije();
          
          if (_res.status===200) {
            _res.res.Popis.forEach((item,index)=>item.rbr=index+1);
            setData(_res.res.Popis);
            
          } else {
            _error=true;
            setMsg({...msg,type:"error",msg:_res.message})
          }
          if (!_error) {
            const _resOrg=await getOrganizatori();
            if (_resOrg.status===200) {
              setOrganizatori(_resOrg.res);
            } else {
              setMsg({...msg,type:"error",msg:_resOrg.message})  
            }
          }


      } catch (error) {
        setMsg({...msg,type:"error",msg:error.message})
      } finally {
          setDataIsLoading(false);          
      }
  
    }
    getData();
  }, [togglerefreshdata])

  const showMsg=()=>{
    
      if (msg.msg!=="") {
        toast({
          title:"RGG",
          status:msg.type,
          description:msg.msg,
          isClosable:true,
          duration:2500,
          position:"top-right",
      });
      setMsg({...msg,type:"",msg:""})
    }
  
}
  const getSkeleton=()=>{
    if (dataisloading) {
      return (
        <Box display={'flex'} flexDir={'column'} flex={1}>
            <SkeletonCircle size='10' />
            <SkeletonText mt='4' noOfLines={30} spacing='3' skeletonHeight='2' />
        </Box>
      )
    }
  }

  const getMenu=()=>{
    if (!dataisloading) {
      return (
        <Box display={'flex'} flexDir={'row'} h='2rem' alignItems={'center'} ml={'1rem'} mr={'1rem'}>
              <Box mr={'0.5rem'}>
                <InputGroup size={size} w='20rem'>
                    <InputLeftElement pointerEvents={'none'} children={<SearchIcon/>}/>
                    <Input focusBorderColor='grunt2.400' placeholder='Filtriranje podataka po nazivu posjednika/klaonice' maxLength={'20'} />
                </InputGroup>
              </Box>
              <IconButton key={'btnFilterOn'} variant={'outline'} colorScheme={'grunt2'} aria-label='Napredno filtriranje' icon={<MdFilterAlt/>} size={size}/>
              <Spacer/>
              <Tooltip label='Unos nove specifikacije' placement='left-start'>
                  <IconButton variant={'outline'} colorScheme={'grunt2'} title='Kreiraj novu specifikaciju' 
                  aria-label='Novo skeniranje' isDisabled={isReadOnly} icon={<MdListAlt size={'sm'}/>} size={size} onClick={()=>setStartNewSpec(true)}/>
              </Tooltip> 
        </Box>
      )  
    }
    
  }
  const handleDeleteSpecifikacija=async(_specid)=>{
    try {
      setDataIsLoading(true);
      const _res=await delSpecifikacija(_specid);
      if (_res.status===200) {
        setMsg({...msg,type:"success",msg:"Specifikacija uspješno pohranjena."})
        setStartNewSpec(false);
        setToggleRefreshData(!togglerefreshdata);
      } else {
        setMsg({...msg,type:"error",msg:_res.message});
      }
  } catch (error) {
    setMsg({...msg,type:"error",msg:error.message});
  } finally {
    setDataIsLoading(false);
  }
  }
  const handleStartEditSpecifikacija=(_specid,_readonly)=>{
    setStartEditSpec({...starteditspec,specid:_specid,start:true,readonly:_readonly});
  }
  const handleCreateMigracija= async(_specid)=>{
    try {
      setDataIsLoading(true);
      const _r=await createMigracijaFromSpecifikacija(_specid);
      if (_r.status===200) {
        setMsg({...msg,type:"success",msg:"Migracije uspješno provedene."})
        setToggleRefreshData(!togglerefreshdata);
      } else {
        setMsg({...msg,type:"error",msg:_r.message});
      }
    } catch (error) {
      setMsg({...msg,type:"error",msg:error.message});
    } finally {
      setDataIsLoading(false);
    }
  }

  const handlePrint=async(_rep,_specid)=>{
    try {
      let _res;
      let _type="";
      let _filename="";
        if (_rep==="rep4") {
          _res=await getSpecifikacijaUsnihMarkicaPdf(_specid);
          _type="application/pdf";
          _filename=`specusmark${_specid}.pdf`;
        } else if (_rep==="rep3"){
          _res=await getVetSpecifikacijaXlsx(_specid);
          _type="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          _filename=`vetspec${_specid}.xlsx`;
        }
          //const file = new Blob([_res.res], { type: "application/pdf" });
          const file = new Blob([_res.res], { type: _type });
          const url = window.URL.createObjectURL(file);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            //a.download = `specusmark${_specid}.pdf`;
            a.download = _filename;
            a.click();
            window.URL.revokeObjectURL(url);
    } catch (error) {
      setMsg({...msg,type:"error",msg:error.message});
    } 
  }

  const handleVetSpecXlsx=async()=>{
   /* const blob = new Blob([res.res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                        
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "Dolasci.xlsx";
            a.click();
            window.URL.revokeObjectURL(url);*/
  }

  const getDataTable=()=>{
    if (!dataisloading) {
      return (
        <Box display={'flex'} flexDir={'column'} flex={1}>
            <SpecifikacijaTable onPrint={handlePrint} readonly={isReadOnly} onCreateMigracija={handleCreateMigracija} onStartEdit={handleStartEditSpecifikacija} onDelete={handleDeleteSpecifikacija} data={data.slice((prikaz.currpage-1)*prikaz.rowsperpage,prikaz.currpage*prikaz.rowsperpage)} />
        </Box>
      )  
    }
    
  }
  const getFooter=()=>{
    return (
      <Box display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
          <GruntPager currpage={prikaz.currpage} rowcount={data.length} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
      </Box>
    )
  }
  const specifikacijaDataCanBeSaved=(canbesaved)=>{
    setSpecDataCanBeSaved(canbesaved);
  }
  const validateSpecifikacijaForAddEdit=()=>{
    let _res="";
    if (novaspecifikacija===null) {
      _res="Potrebno je popuniti podatke specifikacije."
    }
    //goveda
    if (_res==="") {
      if (novaspecifikacija.goveda.length===0) {
        _res="Potrebno je popuniti podatke o govedima.";
      }
    }
    //posjednik
    if (_res==="" && novaspecifikacija.odlazakdetails.migracija_posjednik_id===-1) {
      _res="Nije odabran dolazni posjednik/klaonica.";
    }
    //datumi
    if (_res==="" && novaspecifikacija.odlazakdetails.migracija_datum>novaspecifikacija.odlazakdetails.migracija_ijr) {
      _res="Greška u datumu migracije i/ili datumu isporuke u jedinstveni registar.";
    }
    //organizator
    if (_res==="" && novaspecifikacija.odlazakdetails.organizator_id===0) {
      _res="Nije odabran organizator prijevoza!";
    }

    return _res;
  }
  const onHandleSaveSpecifikacija=async ()=>{
  //validacija
  const _msg=validateSpecifikacijaForAddEdit();
  if (_msg!=="") {
    
    setMsg({...msg,type:"error",msg:_msg});
  } else {
      try {
          setDataIsLoading(true);

          const _g=[];
            for (const _gov of novaspecifikacija.goveda) {
              _g.push({popis_govedo_id:_gov.popis_govedo_id===undefined?-1:_gov.popis_govedo_id,govedo_migracija_id:_gov.govedo_migracija_id})
            }

          if (startnewspec) {//unos nove specifikacije
            
            const _res=await addSpecifikacija(novaspecifikacija.odlazakdetails.kamion_br,
              novaspecifikacija.odlazakdetails.migracija_datum,
              novaspecifikacija.odlazakdetails.migracija_ijr,
              novaspecifikacija.odlazakdetails.migrdok_tip_id,
              novaspecifikacija.odlazakdetails.dokument_broj,
              novaspecifikacija.odlazakdetails.migracija_posjednik_id,
              novaspecifikacija.odlazakdetails.jibg,
              novaspecifikacija.odlazakdetails.uktezina,_g,novaspecifikacija.odlazakdetails.organizator_id);
            if (_res.status===200) {
              setMsg({...msg,type:"success",msg:"Specifikacija uspješno pohranjena."})
              setStartNewSpec(false);
              setToggleRefreshData(!togglerefreshdata);
            } else {
              setMsg({...msg,type:"error",msg:_res.message});
            }  
          } else if (!startnewspec && starteditspec.start) {//ispravak podataka specke
            
            const _res=await updateSpecifikacija(starteditspec.specid,novaspecifikacija.odlazakdetails.kamion_br,
              novaspecifikacija.odlazakdetails.migracija_datum,
              novaspecifikacija.odlazakdetails.migracija_ijr,
              novaspecifikacija.odlazakdetails.migrdok_tip_id,
              novaspecifikacija.odlazakdetails.dokument_broj,
              novaspecifikacija.odlazakdetails.migracija_posjednik_id,
              novaspecifikacija.odlazakdetails.jibg,
              novaspecifikacija.odlazakdetails.uktezina,_g,novaspecifikacija.odlazakdetails.organizator_id);
            if (_res.status===200) {
              setMsg({...msg,type:"success",msg:"Specifikacija uspješno pohranjena."})
              setStartEditSpec({...starteditspec,specid:0,start:false});
              setToggleRefreshData(!togglerefreshdata);
            } else {
              setMsg({...msg,type:"error",msg:_res.message});
            }
          }
          
      } catch (error) {
        setMsg({...msg,type:"error",msg:error.message});
      } finally {
        setDataIsLoading(false);
      }
  }

  }
  const onSpecifikacijaDataChanged=(_s)=>{
    setNovaSpecifikacija(_s);
  }
  const handleCLoseSpecifikacijaItem=()=>{
    setStartNewSpec(false);
    setStartEditSpec({...starteditspec,specid:0,start:false});
  }
 
  const getStartInputOfSpec=()=>{
    if (!dataisloading && (startnewspec || starteditspec.start)) {
      return (
        <Drawer placement='right' size={'xl'} isOpen={true} onClose={()=>setStartNewSpec(false)}>
                <DrawerOverlay/>
                <DrawerContent roundedTopLeft={'md'}>
                <DrawerCloseButton color={'white'}/>
                    <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
                        {startnewspec?"Unos nove specifikacije":"Ispravak/pregled podataka specifikacije"}
                        
                    </DrawerHeader>
                    <DrawerBody display={'flex'} flexDir={'column'} flex={1}>
                      <SpecifikacijaItem organizatori={organizatori} readonly={startnewspec?isReadOnly:starteditspec.readonly} onChange={onSpecifikacijaDataChanged} specifikacijaid={startnewspec?0:starteditspec.specid} onDataCanBeSaved={specifikacijaDataCanBeSaved}/>
                    </DrawerBody>
                    <DrawerFooter display={'flex'} flexDir={'row'}>
                      <Stack direction={'row'} spacing={'2rem'} flex={1}>
                        <Button onClick={onHandleSaveSpecifikacija} isDisabled={!specdatacanbesaved || isReadOnly || (starteditspec.specid!==0 && starteditspec.readonly)} rightIcon={<MdSaveAlt/>} size={size} colorScheme={'grunt2'} variant={'solid'}>Spremi</Button>
                        <Button rightIcon={<MdCancel/>} size={size} colorScheme={'grunt2'} variant={'outline'} onClick={handleCLoseSpecifikacijaItem}>Odustani</Button>
                      </Stack>
                    </DrawerFooter>
                </DrawerContent>
                </Drawer>
      )
    }
  }
    return (
        <Box  display={'flex'} flexDir={'column'} h={'100%'} key='odlasci_component' pl='0.5rem' pr={'0.5rem'} pb={'0.2rem'} borderWidth={'1px'} borderColor={'silver'} borderBottomRightRadius={'md'}>
           <ComponentHeader onClosePress={onClosePress} component={GruntComponents.Specifikacije}/>
           {getSkeleton()}
           {showMsg()}
            {getMenu()}
            {getDataTable()}
            {getStartInputOfSpec()}
            {getFooter()}
          
         
        </Box>
      )
}